'use client'

import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import { T } from '@/components/t'
import { FaqComponent } from '../faq/faq-component'
import { IFaqSectionProps } from '../faq/faq-section'

export const JobsFaqSection = () => {
    const t = useTranslations()

    const sections = useMemo<IFaqSectionProps[]>(() => {
        // biome-ignore lint/suspicious/noExplicitAny: biome migration
        const rawSection = t.raw('jobs.faq.sections' as any)

        return Object.keys(rawSection).map((key) => {
            const section = rawSection[key]
            return {
                title: section.title,
                // biome-ignore lint/suspicious/noExplicitAny: biome migration
                items: section.items.map((item: any) => ({
                    question: item.question,
                    answer: item.answer,
                    cta: item.cta
                        ? {
                              label: item.cta.label,
                              href: item.cta.href,
                          }
                        : undefined,
                })),
            }
        })
    }, [t])

    return (
        <div className="flex w-full flex-col items-center bg-[#F4F4F4]">
            <div className="px-4 py-8 md:py-16 w-full bg-[#F4F4F4] flex justify-center">
                <T h2 t="jobs.faq.title" className="text-center text-[24px] md:text-[32px]" />
            </div>

            <div className="flex flex-col items-center justify-center bg-[#F4F4F4] w-full pb-8 md:pb-16 md:px-20 max-w-[1040px]">
                <FaqComponent withTitles={false} sections={sections} />
            </div>
        </div>
    )
}
